// Foloseste asta pt orice valoare din DB/input utilizator interpolata intr-un string HTML
// (Swal.fire({html:...}), dangerouslySetInnerHTML etc) - previne XSS stocat.
export function escapeHtml(value) {
	if (value == null) return "";
	return String(value)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}
